import React from 'react'
import ReactEcharts from "echarts-for-react";
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const MaturityAnalysis = ({ currentSurvey, stages, leadsData, language_code }) => {
    //States
    const [parsedLeadData, setParsedLeadData] = useState(null)
    const [parseStageData, setParseStageData] = useState(null)
    const colors = ['#E60000', '#FECB00', '#00B0CA', '#A8B400', '#9C2AA0', ' #EB9700', '#5E2750']
    const { t, i18n } = useTranslation();

    //Options
    const maturitySurveys = useMemo(() => {

        let tmpGraphData = {}
        parsedLeadData?.forEach((lead) => {
            parseStageData?.forEach((stage) => {
                if (!tmpGraphData[stage.id]) {
                    tmpGraphData[stage.id] = { count: 0, ...stage }
                }
                if (stage.from <= lead.score && stage.to >= lead.score) {
                    tmpGraphData[stage.id] = {
                        ...tmpGraphData[stage.id],
                        count: tmpGraphData[stage.id].count + 1
                    }
                }
            })
        })

        let series = Object.keys(tmpGraphData)?.map((elementKey, index, arr) => {
            let element = tmpGraphData[elementKey]
            return {
                name: element.name,
                barWidth: '40px',
                type: 'bar',
                stack: 'total',
                emphasis: {
                    focus: 'series'
                },
                data: [((element.count / parsedLeadData?.length) * 100).toFixed(1)],
                itemStyle: {
                    color: colors[index % colors.length]
                },
            }
        })

        series = series.length > 0 ? series : [
            {
                data: null,
            },
            {
                data: null,
            },
            {
                data: null,
            },
            {
                data: null,
            },
            {
                data: null,
            },
            {
                data: null,
            }
        ]

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                valueFormatter: (value) => value + '%'
            },
            legend: {},
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value'
            },

            yAxis: {
                type: 'category',
                data: [''],
                name: currentSurvey?.name ?? '',
                nameLocation: 'middle',
                nameGap: 10,
            },
            // title: {
            //     show: series.length === 0,
            //     textStyle: {
            //         color: 'black',
            //         fontSize:'30px'
            //     },
            //     text: 'No Data',
            //     left: 'center',
            //     top: 'center'
            // },
            series: series
        }
    }, [currentSurvey, parsedLeadData, parseStageData, colors])


    useEffect(() => {
        if (stages && leadsData) {
            let tmpStageData = stages.map((stage) => {
                let name = stage.su_stage_name && JSON.parse(stage.su_stage_name)
                name = name ? name[language_code] : ''
                let formula = stage.su_stage_formulas && JSON.parse(stage.su_stage_formulas)
                let from = formula?.from && Number(formula?.from)
                let to = formula?.to && Number(formula?.to)
                let id = stage.su_survey_stages_id
                return {
                    name,
                    from,
                    to,
                    id
                }
            })

            let tmpLeadData = []

            leadsData?.forEach((row) => {
                if (row.su_is_completed) {
                    let score = row.su_survey_question_score
                    score = score?.split('#')?.reduce((total, scr) => {
                        return total + Number(scr)
                    }, 0)
                    score = score ?? 0

                    tmpLeadData.push({
                        score: score,
                        id: row?.su_survey_submitted_id
                    })
                }
            })

            setParseStageData(tmpStageData)
            setParsedLeadData(tmpLeadData)
        } else {
            setParsedLeadData(null)
            setParseStageData(null)
        }
    }, [stages, leadsData, language_code])


    return (
        <>
            <div className="card dashboard-card min-100">
                <div className="dashboard-card-header mb-4">
                    <h3>{t('analytics.maturity_analysis')}
                    </h3>
                </div>
                <div className="card-body">
                    <div className="chart-text">
                        <ul className='text-data'>
                            <li>{`${t('analytics.totals.completed_leads')}: ${parsedLeadData ? parsedLeadData.length : '0'}`}</li>
                        </ul>
                    </div>
                    <div className="chart-wrapper">
                        <ReactEcharts
                            key={currentSurvey.id}
                            option={maturitySurveys}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default MaturityAnalysis